/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste a URL or text…`)
};

const es_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe o pega una URL o texto…`)
};

const de_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine URL oder einen Text ein oder fügen Sie einen ein…`)
};

const nl_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ of plak een URL of tekst…`)
};

const fr_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez ou collez une URL ou un texte…`)
};

const it_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita o incolla un URL o testo…`)
};

const pt_br2_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole uma URL ou texto…`)
};

const pt_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole um URL ou texto…`)
};

const ja_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLまたはテキストを入力または貼り付けてください…`)
};

const zh_ue_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入或粘贴 URL 或文本…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_placeholder", locale)
	if (locale === "en") return en_ue_placeholder(inputs)
	if (locale === "es") return es_ue_placeholder(inputs)
	if (locale === "de") return de_ue_placeholder(inputs)
	if (locale === "nl") return nl_ue_placeholder(inputs)
	if (locale === "fr") return fr_ue_placeholder(inputs)
	if (locale === "it") return it_ue_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_ue_placeholder(inputs)
	if (locale === "pt") return pt_ue_placeholder(inputs)
	if (locale === "ja") return ja_ue_placeholder(inputs)
	return zh_ue_placeholder(inputs)
};